// Mirrors the wishlist app's item count onto the header icon's dot, the way cart-count
// does for the cart. The app injects its own launcher badge after load and rewrites it as
// items come and go, so the badge is watched rather than read once.
(() => {
  const dot = document.querySelector('[data-wishlist-dot]');

  if (!dot) {
    return;
  }

  const findBadge = () => document.querySelector('#swym-anchor .swym-anchor-badge');

  const sync = () => {
    const count = parseInt((findBadge()?.textContent || '').trim(), 10);
    dot.hidden = !(count > 0);
  };

  const watchBadge = () => {
    const badge = findBadge();

    if (!badge) {
      return false;
    }

    sync();
    new MutationObserver(sync).observe(badge, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    return true;
  };

  if (!watchBadge()) {
    const pending = new MutationObserver(() => {
      if (watchBadge()) {
        pending.disconnect();
      }
    });

    pending.observe(document.body, { childList: true, subtree: true });
  }
})();
